/**
 * The member pages this site no longer serves, now on the member web (my.carebywally.com).
 *
 * A link someone was sent still lands. A booking or standby link carries on to the same link
 * there, where it opens only for the member it belongs to, signed in; any other retired page goes
 * to the member web's home, and the card pages to Billing. Nothing else from the old link is
 * passed on: no encoded ids, emails or campaign values.
 *
 * Check-in goes home too: its encoded id can't be carried, and the member web's home shows the
 * visit that's due with I'm Here. Check-in links are same-day, so old ones go stale fast.
 *
 * public/index.html matches the same paths, so it can take the query off the address bar before
 * any analytics loads; it leaves the query in window.__retiredSearch for this to read.
 */
export const RETIRED_PATH = /^\/(card(\/updated)?|schedule(\/done)?|standby-schedule(\/confirmed)?|confirm(\/success)?|vrdh(\/.*)?|welcome|check-in)\/?$/i

const LINK_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const linkIdIn = (search) => {
  const id = new URLSearchParams(search || '').get('id')
  return id && LINK_ID.test(id) ? id.toLowerCase() : null
}

export const retiredTarget = (pathname, search, portalUrl) => {
  if (!RETIRED_PATH.test(pathname)) {
    return null
  }

  const path = pathname.toLowerCase().replace(/\/+$/, '')
  const linkId = linkIdIn(search)

  if (path === '/card' || path === '/card/updated') {
    return `${portalUrl}/billing`
  }
  if (path === '/schedule') {
    return linkId ? `${portalUrl}/schedule?link=${linkId}` : `${portalUrl}/schedule`
  }
  if (path === '/standby-schedule') {
    return linkId ? `${portalUrl}/schedule?standby=${linkId}` : `${portalUrl}/`
  }
  return `${portalUrl}/`
}
